import React from 'react';
import { IfmsRoute }from '../../../config/types';

const Home = React.lazy(() => import('../Home'));
export const OeMblView = React.lazy(() => import("../mbl/OeMblView"));
export const OeHblView = React.lazy(() => import("../hbl/OeHblView"));
const OeQuotationView = React.lazy(() => import("../quotation/OeQuotationView"));
const OeLoadPlanView = React.lazy(() => import("../loadPlan/OeLoadPlanView"));
export const OeBookingView = React.lazy(() => import("../booking/OeBookingView"));
const OeMblBillingsView = React.lazy(() => import('../mbl/OeMBillingsView'));
const OeHblBillingsView = React.lazy(() => import('../hbl/OeHBillingsView'));
const AesFilingView = React.lazy(() => import('../../reports/AesFilingView'));
const CorrectionNoticeView = React.lazy(() => import('../../reports/CorrectionNoticeView'));
const PickupDeliveryView = React.lazy(() => import('../../reports/PickupDeliveryView'));
const BatchPrintView = React.lazy(() => import('../mbl/more/BatchPrintView'));
const ContainerLoadPlanView = React.lazy(() => import('../mbl/more/ContainerLoadPlanView'));
const AgentDocumentPackageView = React.lazy(() => import('../../reports/AgentDocumentPackageView'));
const FolderLabelView = React.lazy(() => import('../../reports/FolderLabelView'));
const CargoManifestView = React.lazy(() => import('../../reports/CargoManifestView'));
const SendBlView = React.lazy(() => import('../../reports/SendBlView'));
const PrintHblView = React.lazy(() => import('../hbl/more/PrintHblView'));
const BankDraftView = React.lazy(() => import('../../reports/BankDraftView'));
const CertificateOfOriginView = React.lazy(() => import('../../reports/CertificateOfOriginView'));
const DocumentPackageView = React.lazy(() => import('../../reports/DocumentPackageView'));
const CommercialInvoiceView = React.lazy(() => import('../../reports/CommercialInvoiceView'));
const ShippingAdviceView = React.lazy(() => import('../../reports/ShippingAdviceView'));
const AirLabelView = React.lazy(() => import('../../reports/AirLabelView'));
const MemoListView = React.lazy(() => import('../../reports/MemoListView'));
const ItTeNoticeView = React.lazy(() => import('../../reports/ItTeNoticeView'));
const PackageLabelView = React.lazy(() => import('../../reports/PackageLabelView'));
const StraightBlView = React.lazy(() => import('../../reports/StraightBlView'));
const ShipmentReportView = React.lazy(() => import('../reports/ShipmentReportView'));
const BrokerageReportView = React.lazy(() => import('../reports/BrokerageReportView'));
const DownloadView = React.lazy(() => import('../../common/DownloadView'));

const routes:Array<IfmsRoute> = [
  {path: '/oceanExport/home', component: Home},
  {path: '/oceanExport/mbl/:mode/:id?/:tabIndex?/:createEntity?', component: OeMblView},
  {path: '/oceanExport/hbl/:mode/:id?/:tabIndex?/:createEntity?', component: OeHblView},
  {path: '/oceanExport/quotation/:mode/:id?', component: OeQuotationView},
  {path: '/oceanExport/loadPlan/:mode/:id?', component: OeLoadPlanView},
  {path: '/oceanExport/booking/:mode/:id?', component: OeBookingView},
  {path: '/oceanExport/viewBillings/mbl/:id?', component: OeMblBillingsView},
  {path: '/oceanExport/viewBillings/hbl/:id?', component: OeHblBillingsView},

  //OEM Moremenu
  {path: '/oceanExport/oemBatchPrint', component: BatchPrintView},
  {path: '/oceanExport/agentDocumentPackage', component: AgentDocumentPackageView},
  {path: '/oceanExport/containerLoadPlan', component: ContainerLoadPlanView},
  {path: '/oceanExport/cargoManifest', component: CargoManifestView},
  {path: '/oceanExport/sendBl', component: SendBlView},

  //OEH Moremenu
  {path: '/oceanExport/printHbl', component: PrintHblView},
  {path: '/oceanExport/bankDraft', component: BankDraftView},
  {path: '/oceanExport/certificateOfOrigin', component: CertificateOfOriginView},
  {path: '/oceanExport/commercialInvoice', component: CommercialInvoiceView},
  {path: '/oceanExport/packingList', component: CommercialInvoiceView},
  {path: '/oceanExport/documentPackage', component: DocumentPackageView},
  {path: '/oceanExport/itTeNotice', component: ItTeNoticeView},
  {path: '/oceanExport/packageLabel', component: PackageLabelView},
  {path: '/oceanExport/straightBl', component: StraightBlView},
  {path: '/oceanExport/memoCustomerList', component: MemoListView},

  //common Moremenu
  {path: '/oceanExport/aesFiling', component: AesFilingView},
  {path: '/oceanExport/correctionNotice', component: CorrectionNoticeView},
  {path: '/oceanExport/pickupDelivery', component: PickupDeliveryView},
  { path: '/oceanExport/memoList', component: MemoListView },
  { path: '/oceanExport/airLabel', component: AirLabelView },
  { path: '/oceanExport/shippingAdvice', component: ShippingAdviceView },
  { path: '/oceanExport/folderLabel', component: FolderLabelView },
  
  //report
  { path: '/oceanExport/shipmentReport', component: ShipmentReportView },
  { path: '/oceanExport/brokerageReport', component: BrokerageReportView },
  //Download
  { path: '/oceanExport/download/:jobName?/:id?', component: DownloadView },
];

export default routes;
